import { ReactNode } from 'react';
import { Stack } from '@mui/material';

import { GenericTablePagination, ITableLabelDisplayedRows, ITableState } from '/shared/Table';

export const AttachmentPagination = <T extends object>() => {
  function customLabelDisplayedRows({ from, to }: ITableLabelDisplayedRows): ReactNode {
    return (
      <Stack alignItems='center' direction='row' component='span'>
        {from}-{to}
      </Stack>
    );
  }
  return (state: ITableState<T>) => {
    return <GenericTablePagination {...state} labelDisplayedRows={customLabelDisplayedRows} />;
  };
};
